import Decimal from 'decimal.js'
import type { AdminSalesSeriesPoint, SeriesGranularity } from '../api/admin.api'

export type ChartMode = 'cumulative' | 'daily'

/**
 * No gráfico por hora, o dia em andamento para na hora atual. Horas que ainda
 * não começaram ficam de fora, para a linha não seguir reta até o fim do dia.
 */
export function pointsThroughNow(
  points: readonly AdminSalesSeriesPoint[],
  granularity: SeriesGranularity,
  now: number,
) {
  if (granularity !== 'hour' || points.length === 0) return points
  const visible = points.filter((point) => {
    const start = Date.parse(point.bucket)
    return Number.isNaN(start) || start <= now
  })
  return visible.length > 0 ? visible : points
}

/** No máximo algumas dezenas de pontos; preserva cada bucket e soma com precisão decimal. */
export function chartBuckets(points: readonly AdminSalesSeriesPoint[], mode: ChartMode) {
  let accumulated = new Decimal(0)
  return points.map((point) => {
    accumulated = accumulated.plus(point.amount.amount)
    return {
      label: point.bucket,
      through: point.bucket,
      count: point.count,
      amount: mode === 'cumulative' ? accumulated : new Decimal(point.amount.amount),
    }
  })
}

/** Rótulo do eixo conforme a granularidade que o servidor escolheu para a janela. */
export function bucketLabel(bucket: string, granularity: SeriesGranularity): string {
  if (granularity === 'hour') {
    const date = new Date(bucket.includes('T') ? bucket : `${bucket}T00:00:00Z`)
    const hour = new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      hourCycle: 'h23',
      timeZone: 'America/Sao_Paulo',
    }).format(date)
    return `${hour.slice(0, 2)}h`
  }
  const date = new Date(`${bucket}T12:00:00Z`)
  return new Intl.DateTimeFormat('pt-BR', {
    ...(granularity === 'month'
      ? { month: 'short', year: '2-digit' }
      : { day: '2-digit', month: 'short' }),
    timeZone: 'UTC',
  }).format(date)
}
